import React, { useEffect, useRef } from "react";
import Print from "@arcgis/core/widgets/Print";
import './Print.css';
import { useAuth } from "../../../Providers/AuthProvider/AuthProvider";
import PrintIcon from "../../../assets/print/printLogo.svg"; // Correct import path
import { queries } from "@testing-library/react";
import config from "../../Common/config";

const PrintComponent = ({ mapview }) => {
  const printRef = useRef(null);
  const { setprintWidget } = useAuth();

  useEffect(() => {
    const applyStyles = () => {
      const calciteButtons = document.querySelectorAll('calcite-button[kind="brand"]');

      calciteButtons.forEach((calciteButton) => {
        if (calciteButton.shadowRoot) {
          const interactionContainer = calciteButton.shadowRoot.querySelector('.interaction-container');
          if (interactionContainer) {
            // Check if the stylesheet has already been applied to avoid duplication
            if (!calciteButton.shadowRoot.adoptedStyleSheets.some(sheet => sheet.ownerNode?.id === 'custom-styles')) {
              // Create a constructed stylesheet
              const styleSheet = new CSSStyleSheet();
              styleSheet.replaceSync(`
                .interaction-container button {
                  background: linear-gradient(
                    270.18deg,
                    #036068 -14.27%,
                    #596451 47.55%,
                    #1E7C87 76.37%,
                    #4C7950 107.69%,
                    #1199A8 147.31%
                  ) !important;
                  color: var(--calcite-color-text-inverse) !important;
                  border-radius: 10px !important;
                }
              `);

              // Apply the constructed stylesheet to the shadowRoot
              calciteButton.shadowRoot.adoptedStyleSheets = [
                ...calciteButton.shadowRoot.adoptedStyleSheets,
                styleSheet,
              ];
            }
          }
        }
      });
    };

    // MutationObserver to detect when new elements are added to the DOM
    const observer = new MutationObserver((mutations) => {
      applyStyles();
    });

    // Start observing the body for any child additions
    const bodyNode = document.querySelector('body');
    if (bodyNode) {
      observer.observe(bodyNode, { childList: true, subtree: true });
    }

    // Retry mechanism with timeout to give elements more time to load
    const intervalId = setInterval(() => {
      applyStyles();
    }, 100);

    // Stop retrying after 5 seconds
    setTimeout(() => {
      clearInterval(intervalId);
    }, 5000);

    // Apply styles initially in case elements already exist
    applyStyles();

    // Cleanup on unmount
    return () => {
      observer.disconnect();
      clearInterval(intervalId);
    };
  }, []);

  // useEffect(() => {
  //   let timeout;

  //   const applyPrintTabStyling = () => {
  //     const layoutTab = document.querySelector("#printDiv__layoutTab");
  //     if (layoutTab) {
  //       layoutTab.textContent = "Print";
  //     }

  //     // If needed in future
  //     // const exportsTab = document.querySelector("#printDiv__exportedFilesTab");
  //     // if (exportsTab) {
  //     //   exportsTab.textContent = "Result";
  //     // }
  //   };

  //   const observer = new MutationObserver(() => {
  //     clearTimeout(timeout);
  //     timeout = setTimeout(() => {
  //       applyPrintTabStyling();
  //     }, 100); // Debounce to avoid rapid repeated calls
  //   });

  //   const targetNode = document.querySelector("#printDiv");
  //   if (targetNode) {
  //     observer.observe(targetNode, { childList: true, subtree: true });
  //   }

  //   return () => {
  //     clearTimeout(timeout);
  //     observer.disconnect();
  //   };
  // }, []);

  // useEffect(() => {
  //   // MutationObserver for dynamic content updates
  //   const observer = new MutationObserver(() => {
  //     const layoutTab = document.querySelector('#printDiv__layoutTab');
  //     if (layoutTab) layoutTab.textContent = 'Print';

  //     // const exportsTab = document.querySelector('#printDiv__exportedFilesTab');
  //     // if (exportsTab) exportsTab.textContent = 'Result';
  //   });



  //   const targetNode = document.querySelector('#printDiv');
  //   if (targetNode) {
  //     observer.observe(targetNode, { childList: true, subtree: true });
  //   }

  //   // Cleanup observer on unmount
  //   return () => observer.disconnect();
  // }, []);

  useEffect(() => {
    if (mapview && printRef.current) {
      try {
        const operationalLayers = mapview.map.layers
          .filter(layer => layer.listMode !== "hide" && layer.visible && layer.type !== "basemap")
          .map(layer => ({
            // layerId: layer.id,
            title: layer.title.split("_")[0]
          }));
        mapview.map.allLayers.forEach(layer => {
          if (layer.type === "tile" || layer.type === "basemap") {
            if (layer.sublayers) {
              layer.sublayers.forEach(sublayer => {
                sublayer.legendEnabled = false; // Enable legend for each sublayer
              });
            }
            layer.legendEnabled = false; // Enable legend for the layer
          }
          else{
            // layer.title = layer.title.split("_")[0]
            if (layer.allSublayers){
              layer.allSublayers.forEach(sublayer => {
                const titleParts = sublayer.title.split(" ");
                sublayer.title = titleParts.length > 1 ? `${titleParts[0]} ${titleParts[1]}` : titleParts.join(" ");
              })
            }
          }
        });
        const printWidget = new Print({
          view: mapview,
          container: printRef.current,
          printServiceUrl: config.Print.printServiceUrl,
          allowedFormats: config.Print.allowedFormats,
          allowedLayouts: config.Print.allowedLayouts,
          templateOptions: {
            title: "My Print",
            layoutOptions: {
              // legendLayers: operationalLayers, // ✅ Only operational layers here
            },
          },
        });

        // Store the printWidget in the AuthProvider state
        setprintWidget(printWidget);
        printWidget.on("error", function (error) {
          console.log("printError", error)
        })
        printWidget.on("complete", function (evt){
          console.log(evt)
        })

        // Observe for changes in the printRef container to remove the "Map Only" tab when it appears
        const observer = new MutationObserver(() => {
          const liElement = document.getElementById('printDiv__mapOnlyTab');
          if (liElement) {
            liElement.remove(); // Remove the <li> element directly
            observer.disconnect(); // Stop observing once the element is removed
          }
        });

        observer.observe(printRef.current, { childList: true, subtree: true });

        return () => {
          if (printRef.current) {
            //printRef.destroy();
            printRef.current = null;
          }
        };
      } catch (error) {
        console.error("Error initializing print widget:", error);
      }
    }
  }, [mapview]);

  useEffect(() => {
    let timeout;

    const applyEsriStyling = () => {
      const combobox = document.querySelector("calcite-combobox");
      const button = document.querySelector("calcite-button");

      if (combobox?.shadowRoot) {
        const wrapper = combobox.shadowRoot.querySelector(".wrapper");
        if (wrapper) {
          wrapper.style.borderColor = "white";
          wrapper.style.height = "40px";
          wrapper.style.borderRadius = "12px";
        }
      }

      if (button?.shadowRoot) {
        const buttonContainer = button.shadowRoot.querySelector(".interaction-container");
        if (buttonContainer) {
          // Optionally apply styling to button container if needed
          // buttonContainer.style.someProperty = "value";
        }
      }

      // Update the print button text
      const printButton = document.querySelector(".esri-button");
      if (printButton) {
        printButton.textContent = "Print";
      }

      // Update general wrapper class
      const layoutWrapper = document.querySelector(".wrapper");
      if (layoutWrapper) {
        layoutWrapper.style.border = "white";
      }
    };

    const observer = new MutationObserver(() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        applyEsriStyling();
      }, 100); // Debounce
    });

    const bodyNode = document.querySelector("body");
    if (bodyNode) {
      observer.observe(bodyNode, { childList: true, subtree: true });
    }

    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, []);

  // useEffect(() => {
  //   // Update ESRI button text content after widget initialization
  //   const buttonObserver = new MutationObserver(() => {
  //     // Safely check for the calcite-combobox and its shadowRoot
  //     const calciteCombobox = document.querySelector('calcite-combobox');
  //     const calcitebutton = document.querySelector('calcite-button');
  //     const WrapperShadow = calciteCombobox?.shadowRoot?.querySelector('.wrapper');
  //     const WrapperShadowButton = calcitebutton?.shadowRoot?.querySelector('.interaction-container');

  //     if (WrapperShadow) {
  //       WrapperShadow.style.borderColor = "white";
  //       WrapperShadow.style.height = "40px";
  //       WrapperShadow.style.borderRadius = "12px";
  //     }

  //     // Update the print button text
  //     const printButton = document.querySelector('.esri-button');
  //     if (printButton) {
  //       printButton.textContent = 'Print';
  //     }

  //     // Update the layout wrapper styling
  //     const toggleLayout = document.querySelector('.wrapper');
  //     if (toggleLayout) {
  //       toggleLayout.style.border = 'white';
  //     }
  //   });

  //   // Start observing the body or container where the button is rendered
  //   const bodyNode = document.querySelector('body');
  //   if (bodyNode) {
  //     buttonObserver.observe(bodyNode, { childList: true, subtree: true });
  //   }

  //   // Cleanup observer on unmount
  //   return () => buttonObserver.disconnect();
  // }, []);






  return <div
    className="  h-[360px] pb-4 mobile_m_360:pb-0 mobile_m_360:h-auto overflow-auto "
    //  className=" sm:-mt-[500px] tab:-mt-[100%] h-[400px] laptop_s:h-[353px] overflow-auto   laptop_s:-mt-[365px] laptop_m:-mt-[400px] laptop_lg:-mt-[130%] laptop_lg_2:-mt-[120%] -mt-[420px]"
    id="printDiv" ref={printRef} />;
};

export default PrintComponent;
